<button class="btn btn-primary workflow-view mt-1 mb-3" data-test="view-btn"
        ngbTooltip="{{'submission.workspace.generic.view-help' | translate}}"
        [routerLink]="[getWorkflowItemViewRoute(object)]">
  <i class="fa fa-info-circle"></i> {{"submission.workspace.generic.view" | translate}}
</button>
